import {
  HTTPQuery,
  DeleteBudgetRequest,
  DeleteBudgetRequestToJSON,
  GetBudgetRequest,
  GetBudgetRequestToJSON,
  UpdateBudgetRequest,
  UpdateBudgetRequestToJSON,
  Budget,
  BudgetFromJSON
} from '@/api'
import * as runtime from '../runtime'

export class BudgetApi extends runtime.BaseAPI {
  /**
   * 予算情報を取得する
   * 予算情報取得
   */
  async getBudgets(request: GetBudgetRequest): Promise<Budget[]> {
    const queryParameters: runtime.HTTPQuery = Object.fromEntries(
      Object.entries(GetBudgetRequestToJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery
    const response = await this.requestGet('/budgets', queryParameters)

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(BudgetFromJSON)
    ).value()
  }

  /**
   * 予算情報を更新する
   * 予算情報更新
   */
  async updateBudgets(
    request: UpdateBudgetRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = UpdateBudgetRequestToJSON(request)
    const response = await this.requestPost('/budgets', bodyParameters)

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 予算情報を更新する
   * 予算情報更新
   */
  async deleteBudgets(
    request: DeleteBudgetRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = DeleteBudgetRequestToJSON(request)
    const response = await this.requestDelete('/budgets', bodyParameters)

    return new runtime.VoidApiResponse(response)
  }
}
